import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('app', ['mobileMenuOpened']),
    classModifiers() {
      return {
        'hamburger-icon': true,
        'hamburger-icon--opened': this.mobileMenuOpened,
      };
    },
    text() {
      return this.mobileMenuOpened ? 'Close' : 'Menu';
    },
  },
  methods: {
    ...mapActions('app', ['toggleMobileMenu']),
  },
};



// WEBPACK FOOTER //
// ./src/components/hamburger-icon/hamburger-icon.js